export default "__VITE_ASSET__BNvRWwQ6__"